import { FC, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { ADD_TO_CART_MODAL_TYPES } from '../../../../../common/add-to-cart-modal/add-to-cart-modal.constants';
import SlideDown from '../../../../../common/add-to-cart-modal/components/slide-down/slide-down';
import Routes from '../../../../../constants/routes';
import { ReactComponent as Cart } from '../../../../../images/icon-warenkorb_.svg';
import translation from '../../../../../languages';
import { getCart } from '../../../../../reducers/cart';
import cn from '../../../../../utils/classnames';
import { domainLinkCreator } from '../../../../../utils/domain-manager';
import pubsub from '../../../../../utils/pubsub';
import './warenkorb-menu.scss';

type WarenkorbMenuProps = TranslationProps & {
    getCart: typeof getCart;
};

const WarenkorbMenu: FC<WarenkorbMenuProps> = ({ t, getCart }) => {
    const cart = useSelector((state: RootState) => state.main.cart);
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );
    const [showSlide, setShowSlide] = useState(false);
    const [temporary, setTemporary] = useState(false);
    const isLiving = useRef(false);

    useEffect(() => {
        getCart();

        pubsub.subscribe('cartSlideDown', (e: Event, data = { type: ADD_TO_CART_MODAL_TYPES.SUCCESS }) => {
            setTemporary(true);

            setTimeout(() => {
                setTemporary(false);
            }, 4000);
        });

        return () => pubsub.unsubscribe('cartSlideDown');
    }, []);

    const warenkorbContent = () => {
        const empty = cart.cartItems.length ? '' : 'empty';

        return (
            <div className='align-items-center d-flex justify-content-between flex-column w-link'>
                <div className={`icon-wrapper position-relative ${empty}`} data-amount={cart.cartItems.length}>
                    <Cart className='w-icon' />
                </div>
                <span className={cn('d-none d-lg-block', { 'tsc-caption': isActiveNavigationAbTest })}>
                    {t('header.icons.cartMenu.title')}
                </span>
            </div>
        );
    };

    const onMouseLeave = () => {
        isLiving.current = true;
        setTimeout(() => {
            if (isLiving.current) {
                setShowSlide(false);
            }
        }, 500);
    };

    return (
        <a
            onMouseEnter={() => {
                setShowSlide(true);
                isLiving.current = false;
            }}
            onMouseLeave={onMouseLeave}
            className='warenkorb-menu d-flex align-items-center justify-content-center'
            href={domainLinkCreator(Routes.WARENKORB.path)}
            onClick={() => {
                window.locationReload(domainLinkCreator(Routes.WARENKORB.path));
            }}
        >
            {warenkorbContent()}
            <SlideDown temporaryShow={temporary} shouldShow={showSlide} />
        </a>
    );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            getCart
        },
        dispatch
    );

const translate = translation('header');

export default connect(() => ({}), mapDispatchToProps)(translate(WarenkorbMenu));
